import React, { useState } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap"
import { Link } from "react-router-dom"
import "../../newcomponents/index.css"
import { useSelector } from "react-redux"

const DoctorsCard = ({ doctors = [] }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const doctorsPerPage = 4
  const mode = useSelector(state => state.Layout.layoutMode)

  // Ensure doctors is always an array
  const validDoctors = Array.isArray(doctors) ? doctors : []

  // Pagination Logic
  const indexOfLastDoctor = currentPage * doctorsPerPage
  const indexOfFirstDoctor = indexOfLastDoctor - doctorsPerPage
  const currentDoctors = validDoctors.slice(
    indexOfFirstDoctor,
    indexOfLastDoctor,
  )
  const totalPages = Math.max(
    1,
    Math.ceil(validDoctors.length / doctorsPerPage),
  )

  // Handle Page Change
  const paginate = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber)
    }
  }

  return (
    <React.Fragment>
      <Card 
        className="br"
        style={{
          borderRadius: "20px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardBody style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Row className="align-items-center">
            <Col xl={6} lg={6} md={6} className="d-flex align-items-center">
              <CardTitle
                className={`h4 mb-3 ${mode === "dark" ? "dark-text" : "light-text"}`}
              >
                Doctors List
              </CardTitle>
            </Col>
          </Row>

          {/* Doctors List - Fixed Height with Scroll */}
          <div
            className="inbox-wid"
            style={{ 
              flex: 1,
              overflowY: "auto",
              minHeight: "400px",
              maxHeight: "400px",
              marginBottom: "1rem"
            }}
          >
            {currentDoctors.length > 0 ? (
              currentDoctors.map((doctor, key) => (
                <Link
                  key={key}
                  to="#"
                  className="text-dark text-decoration-none"
                >
                  <div className="inbox-item d-flex align-items-center border rounded p-3 mb-2 shadow-sm">
                    <div className="inbox-item-img me-3">
                      <img
                        src={doctor.doctorAvatar}
                        className="avatar-sm rounded-circle"
                        alt={doctor.doctorName}
                      />
                    </div>
                    <div>
                      <h6 className="mb-1 font-size-16 font-weight-bold">
                        {doctor.doctorName}
                      </h6>
                      <p className="text-muted mb-0">
                        {doctor.doctorSpeciality}
                      </p>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <p>No doctors available.</p>
            )}
          </div>

          {/* Pagination - Fixed at Bottom */}
          <Pagination className="mb-0 justify-content-center mt-auto">
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink
                style={{
                  color: mode === "dark" ? "#fff" : "#000",
                  backgroundColor: "transparent",
                  borderColor: mode === "dark" ? "#444" : "#dee2e6",
                }}
                previous
                onClick={() => paginate(currentPage - 1)}
              />
            </PaginationItem>

            {Array.from({ length: totalPages }).map((_, i) => (
              <PaginationItem active={i + 1 === currentPage} key={i}>
                <PaginationLink
                  style={{
                    borderColor:
                      i + 1 === currentPage
                        ? "#2990DF"
                        : mode === "dark"
                          ? "#444"
                          : "#dee2e6",
                    boxShadow: "none",
                    backgroundColor:
                      i + 1 === currentPage ? "#2990DF" : "transparent",
                    color:
                      i + 1 === currentPage
                        ? "#fff"
                        : mode === "dark"
                          ? "#fff"
                          : "#000",
                  }}
                  onClick={() => paginate(i + 1)}
                >
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}

            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink
                style={{
                  color: mode === "dark" ? "#fff" : "#000",
                  backgroundColor: "transparent",
                  borderColor: mode === "dark" ? "#444" : "#dee2e6",
                }}
                next
                onClick={() => paginate(currentPage + 1)}
              />
            </PaginationItem>
          </Pagination>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default DoctorsCard